<div class="warning-modal-body row no-gutters">
  <div class="col col-auto">
    <key-icon
      class="confirmation-modal-icon-image"
      size="lg"
      theme="light-outline"
      kind="error"
      set="typcn"
      icon="cancel-outline"
    />
  </div>
  <div class="col modal-content">
    <h3 class="font-size-20 pb-3 color-bg-text-primary">
      {{ data.modalTitle | translate }}
    </h3>
    <p
      class="modal-text color-bg-text-secondary"
      [innerHTML]="data.text | translate | replaceNewLine"
    ></p>
    <div
      class="d-flex justify-content-end align-items-center modal-buttons mt-4"
    >
      <button
        type="button"
        class="modal-button btn-primary"
        (click)="dismiss()"
      >
        {{ data.buttonText | translate | uppercase }}
      </button>
    </div>
  </div>
</div>
